module.exports = __webpack_public_path__ + "img/vapor storm.68346a01.png";